import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import Markdown from 'react-markdown';

const PrivacyPolicy = () => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const docRef = doc(db, 'legal', 'texts');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists() && docSnap.data().privacyPolicy) {
          setContent(docSnap.data().privacyPolicy);
        } else {
          // Fallback content
          setContent(`
# Política de Privacidade - UNIFIG

Última atualização: 13 de Março de 2026

Na UNIFIG (União dos Deficientes Físicos de Iguatemi), a privacidade e a segurança dos dados de nossos pacientes, familiares, voluntários e visitantes são prioridades fundamentais. Esta política explica como coletamos, usamos e protegemos suas informações.

## 1. Coleta de Informações
Coletamos informações necessárias para o atendimento multidisciplinar e para a comunicação institucional, tais como:
- Dados de identificação (nome, CPF, RG);
- Informações de contato (e-mail, telefone, endereço);
- Dados de saúde (necessários para o prontuário de atendimento).

## 2. Uso de Cookies
Nosso site utiliza cookies para melhorar sua experiência de navegação. Você pode configurar suas preferências através do nosso banner de consentimento.

## 3. Armazenamento e Segurança
Seus dados são armazenados em servidores seguros e protegidos por medidas técnicas e administrativas para evitar acessos não autorizados.

## 4. Seus Direitos
De acordo com a LGPD, você tem direito a acessar, corrigir ou solicitar a exclusão de seus dados pessoais a qualquer momento.

## 5. Contato
Para dúvidas sobre privacidade, entre em contato pelo e-mail: michellicazelli@hotmail.com
          `);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <main>
      <PageHeader title="Política de Privacidade" description="Saiba como protegemos e tratamos seus dados pessoais na UNIFIG." />
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate prose-blue max-w-none">
            {loading ? (
              <div className="animate-pulse space-y-4">
                <div className="h-8 bg-slate-100 rounded w-1/2" />
                <div className="h-4 bg-slate-100 rounded w-full" />
                <div className="h-4 bg-slate-100 rounded w-full" />
                <div className="h-4 bg-slate-100 rounded w-3/4" />
              </div>
            ) : (
              <Markdown>{content}</Markdown>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
